import { Const, Etapas } from '@app/shared';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Logger } from '../../../core/utilities/logger.service';

const log = new Logger('StagePreviewComponent');

@Component({
  selector: 'iw-stage-preview',
  templateUrl: './stage-preview.component.html',
  styleUrls: ['./stage-preview.component.scss'],
  providers: []
})
export class StagePreviewComponent implements OnInit, OnDestroy {
  // Contiene las etapas del tramite ( etapa actual y general)
  @Input() stage: Etapas;
  // Asignacion de las constantes de los estados de las etapas
  success = Const.STAGESTATUS.upToDay;
  warning = Const.STAGESTATUS.toExpire;
  danger = Const.STAGESTATUS.expired;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor() { }

  ngOnInit() { }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/title-preview/stage-preview/stage-preview.component.ts